import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { WC_API_HEADER_KEY, WC_API_URL } from "../config/config";

export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [user, setUser] = useState(null);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const userDataString = localStorage.getItem("user");
  if (!userDataString) {
    setLoading(false); // no user, done loading
    return;
  }

  const userData = JSON.parse(userDataString);
  if (!userData.partnerCode || !userData.type) {
    setLoading(false);
    return;
  }

  const fetchUser = async () => {
    try {
      let res;
      if (userData.type === "referralPartner") {
        res = await axios.get(`${WC_API_URL}/referralPartners/bycode?code=${userData.partnerCode}`,
          { headers: { 'x-internal-key': WC_API_HEADER_KEY } }
        );
      } else if (userData.type === "wcPartner") {
        res = await axios.get(`${WC_API_URL}/partners/bycode?partnerCode=${userData.partnerCode}`,
          { headers: { 'x-internal-key': WC_API_HEADER_KEY } }
        );
      }
      const data = res?.data?.data || {};
      setUser({ ...data, type: userData.type });
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setLoading(false); // ✅ fetch done
    }
  };

  fetchUser();
}, []);

  // // 🔥 Auto sync to localStorage
  // useEffect(() => {
  //   if (user) {
  //     localStorage.setItem("user", JSON.stringify(user));
  //   } else {
  //     localStorage.removeItem("user");
  //   }
  // }, [user]);

  return (
    <ProfileContext.Provider value={{ user, setUser,loading }}>
      {children}
    </ProfileContext.Provider>
  );
};